import { HOME_ROUTE_PATH } from '@flowwai-frontend/bps-officer-web/common/data-access'

const CLOCK_IN_SUCCESS_PATH = 'clockin_success_path'

export function setClockInRedirectPath(path = HOME_ROUTE_PATH) {
   window.localStorage.setItem(CLOCK_IN_SUCCESS_PATH, path)
}

export function getClockInRedirectPath(): string {
   return window.localStorage.getItem(CLOCK_IN_SUCCESS_PATH) || HOME_ROUTE_PATH
}

export const clearClockInRedirectPath = (): void => {
   window.localStorage.removeItem(CLOCK_IN_SUCCESS_PATH)
}
